import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import codigoPostalChecker from "@helpers/codigoPostal/codigoPostalChecker";
import capitalizeString from "@helpers/strings/capitalizeString/capitalizeString";
import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Accordion, Button, Col, Container, FloatingLabel, Form, Row, useAccordionButton } from "react-bootstrap";

import UseAnimations from "react-useanimations";
import searchToX from "react-useanimations/lib/searchToX";
import { extraerRegionesSai, getEstadosSai, getMunicipiosSai } from "../../../helpers/httpRequests/httpRequestsSAI/httpRequestsSAI";

const AccordionDatosDomicilio = ({ isCreditoDirecto, formValues, setFormValues, compraLectura }) => {


	const nextEventKey = isCreditoDirecto ? "3" : "4";

	const decoratedOnClick = useAccordionButton(nextEventKey);

	const { codigoPostal, calle, ciudad, estado, numeroExterior, numeroInterior, entreCalles, tiempoResidencia, colonia } = formValues;

	const [colonias, setColonias] = useState([]);

	const [searchingPostalCode, setSearchingPostalCode] = useState(false);

	const [regionesSAI, setRegionesSai] = useState([]);
	
	const [estados, setEstados] = useState([]);

	const [idEstado, setIdEstado] = useState(-1);

	const [estadoSeleccionado, setEstadoSeleccionado] = useState(false);

	const [municipios, setMunicipios]= useState([]);

	const consultarDatosCodigoPostal = async () => {
		try {

			setSearchingPostalCode(true);

			const { colonias, ciudad: ciudadEncontrada, estado: estadoEncontrado } = await codigoPostalChecker(codigoPostal);
			console.log({
				colonias,
				ciudadEncontrada,
				estadoEncontrado
			})
			setFormValues({
				...formValues,
				ciudad: ciudadEncontrada,
				estado: estadoEncontrado,
			});

			setColonias(colonias);

			setTimeout(() => setSearchingPostalCode(false), 1000);
		} catch (error) {
			console.log("Error al obtener los datos del código postal: ", error);
		}
	};

	const handleOnChangeEstado = ({target}) => {
        const {name, value} = target;
        setEstadoSeleccionado(false);

        let estado = estados.find((state) => state.nombre === value);
        console.log(estado);

        setIdEstado(estado.idEstado);

        setFormValues({
            ...formValues,
            ciudad: value
        })
    }

      const handleOnChangeMunicipio = ({target}) => {
        const {name, value} = target;

        setFormValues({
            ...formValues,
            estado: value
        })
    }

	const getEstados = async() => {
		try {
			const estados = await getEstadosSai(formValues.region);
			console.log(estados);
			setEstados(estados.data);
		} catch (error) {
			console.log("Error al obtener los estados: ", error);
		}
	};

	const getMunicipios = async() => {
		try {
			const municipios = await getMunicipiosSai(idEstado);
			console.log(municipios);
			setMunicipios(municipios.data)
		} catch (error) {
			console.log("Error al obtener los municipios: ", error);
		}
	}

	const consultarRegiones = async() => {
		try{
			const regiones = await extraerRegionesSai();
			console.log(regiones)
			if(Array.isArray(regiones.data)){
				setRegionesSai(regiones.data);
			}else{
				setRegionesSai([regiones.data]);
			}
		}catch(error){
			console.log("Hubo un error al recuperar las regiones del SAI");
		}
	}

	const handleOnChangeRegion = ({target}) => {
		const {name, value} = target;
		console.log(name, value)
		setFormValues({
			...formValues,
			[name]: parseInt(value),
		})
	}

	const handleOnChange = ({ target }) => {
		let auxValues = {};

		switch (target.name) {
			case "codigoPostal":
			case "numeroExterior":
			case "numeroInterior":
				auxValues = {
					[target.name]: target.value.replace(/\D/g, ""),
				};
				break;
				
				case "calle":
				case "entreCalles":
				case "tiempoResidencia":
					auxValues = {
						[target.name]: capitalizeString(target.value),
					};
				break;

			default:
				auxValues = {
					[target.name]: target.value,
				};
				break;
		}

		setFormValues({
			...formValues,
			...auxValues,
		});
	};

	useEffect(() => {
		consultarRegiones();
		getEstados();
	}, []);

	
	useEffect(() => {
		getEstados();
	}, [formValues.region])

	useEffect(() => {
		if(idEstado !== -1){
			getMunicipios()
		}
	}, [idEstado])

	// useEffect(() => {
	// 	if (codigoPostal.length === 5) {
	// 		consultarDatosCodigoPostal();
	// 	}
	// }, [codigoPostal]);

	return (
		<Accordion.Item eventKey="2">
			<Accordion.Header>
				<Typography variant="button">Datos de Domicilio</Typography>
			</Accordion.Header>

			<Accordion.Body>
				<Container fluid>
						<Row className="mb-3">
							<Col>
								<Form.Select name="region" onChange={handleOnChangeRegion} size="lg" aria-label="Default select example">
									<option>Selecciona tu ubicación</option>
									{regionesSAI.map((region, idxRegion) => (
										<option value={region.regionId}>{region.nombreRegion}</option>
									))}
								</Form.Select>
							</Col>
						</Row>
					<Row>
						<Col xs={12} md={6}>
							<FloatingLabel label="Código Postal" className="mb-3">
								<Form.Control type="text" placeholder="Código Postal" name="codigoPostal" value={codigoPostal} onChange={handleOnChange} />

								{/* {searchingPostalCode ? (
									<Form.Text className="text-muted">
										<div className="d-flex justify-content-end">
											<UseAnimations animation={searchToX} size={56} strokeColor="#ffcc00" loop autoplay speed={0.5} />
										</div>
									</Form.Text>
								) : null} */}
							</FloatingLabel>
						</Col>

						<Col xs={12} md={6}>
							<FloatingLabel label="Calle" className="mb-3">
								<Form.Control type="text" placeholder="Calle" name="calle" value={calle} onChange={handleOnChange} />
							</FloatingLabel>
						</Col>
					</Row>

					<Row>
						<Col xs={12} md={6} className="mb-3">
							<FloatingLabel label="Colonia">
								{/* <Form.Select aria-label="Elige tu colonia" name="colonia" onChange={handleOnChange}>
									<option value="">{colonias.length > 0 ? "Elige una colonia" : "Ingresa tu código postal"}</option>

									{colonias.map((colonia, idx) => (
										<option value={colonia} key={idx}>
											{colonia}
										</option>
									))}
								</Form.Select> */}

								<Form.Control type="text" placeholder="Colonia" name="colonia" value={colonia} onChange={handleOnChange} />

							</FloatingLabel>
						</Col>

						<Col xs={12} md={6}>
							<Row>
								<Col xs={12} md={6}>
									<FloatingLabel label="Número exterior" className="mb-3">
										<Form.Control type="text" placeholder="Número exterior" name="numeroExterior" value={numeroExterior} onChange={handleOnChange} />
									</FloatingLabel>
								</Col>

								<Col xs={12} md={6}>
									<FloatingLabel label="Número interior" className="mb-3">
										<Form.Control type="text" placeholder="Número interior" name="numeroInterior" value={numeroInterior} onChange={handleOnChange} />

										<Form.Text className="text-muted">Opcional</Form.Text>
									</FloatingLabel>
								</Col>
							</Row>
						</Col>
					</Row>

					<Row>
						<Col xs={12} md={6}>
							<Row>
								<Col xs={12} md={6}>
									{/* <FloatingLabel label="Ciudad" className="mb-3">
										<Form.Control type="text" placeholder="Ciudad" name="ciudad" value={ciudad} onChange={handleOnChange} />
									</FloatingLabel> */}
									<Form.Select name="ciudad" onChange={handleOnChangeEstado} size="lg" aria-label="Default select example">
										<option>Selecciona</option>
										{estados.length > 0 && (
											estados.map((estado, idxEstado) => (
												<option value={estado.nombre}>{estado.nombre}</option>
											))
										)}
									</Form.Select>
								</Col>

								<Col xs={12} md={6}>
									{/* <FloatingLabel label="Estado" className="mb-3">
										<Form.Control type="text" placeholder="Estado" name="estado" value={ estado} onChange={handleOnChange} />
									</FloatingLabel> */}
									 <Form.Select disabled={estadoSeleccionado} name="estado" onChange={handleOnChangeMunicipio} size="lg" aria-label="Default select example">
										<option>Selecciona</option>
										{municipios.map((municipio, idxMunicipio) => (
											<option value={municipio.nombre}>{municipio.nombre}</option>
										))}
									</Form.Select>
								</Col>
							</Row>
						</Col>

						{isCreditoDirecto ? (
							<Col xs={12} md={6}>
								<FloatingLabel label="Entre calles" className="mb-3">
									<Form.Control type="text" placeholder="Entre calles" name="entreCalles" value={entreCalles} onChange={handleOnChange} />
								</FloatingLabel>
							</Col>
						) : (
							<Col xs={12} md={6}>
								<div className="d-grid gap-2 mb-3">
									<Button className="btn-next-accordion" variant="success" type="button" size="lg" onClick={decoratedOnClick}>
										Siguiente <FontAwesomeIcon icon={faArrowRight} />
									</Button>
								</div>
							</Col>
						)}
					</Row>

					<Row>
						{isCreditoDirecto ? (
							<Col xs={12} md={6}>
								<FloatingLabel label="Tiempo de residencia" className="mb-3">
									<Form.Control type="text" placeholder="Tiempo de residencia" name="tiempoResidencia" value={tiempoResidencia} onChange={handleOnChange} />
								</FloatingLabel>
							</Col>
						) : null}

						{isCreditoDirecto ? (
							<Col xs={12} md={6}>
								<div className="d-grid gap-2 mb-3">
									<Button className="btn-next-accordion" variant="success" type="button" size="lg" onClick={decoratedOnClick}>
										Siguiente <FontAwesomeIcon icon={faArrowRight} />
									</Button>
								</div>
							</Col>
						) : null}
					</Row>
				</Container>
			</Accordion.Body>
		</Accordion.Item>
	);
};

export default AccordionDatosDomicilio;
